import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoaderComponent } from '../component/loader/loader.component';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private overlayRef: OverlayRef | null = null;
  private requestCount = 0;

  constructor(private overlay: Overlay, private injector: Injector) { }

  show() {
    this.requestCount++;
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'loader-backdrop',
        panelClass: 'loader-panel',
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
      });

      const loaderPortal = new ComponentPortal(LoaderComponent, null, this.injector);
      this.overlayRef.attach(loaderPortal);
    }
  }

  hide() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0 && this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}